import { render, staticRenderFns } from "./DesignFormItem.vue?vue&type=template&id=7a2d7e98&scoped=true&"
import script from "./DesignFormItem.vue?vue&type=script&lang=js&"
export * from "./DesignFormItem.vue?vue&type=script&lang=js&"
import style0 from "./DesignFormItem.vue?vue&type=style&index=0&id=7a2d7e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a2d7e98",
  null
  
)

export default component.exports